import React from 'react';
import { IconCheck, IconClock, IconArrowRight } from '@tabler/icons-react';

const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : null;

function StepChip({ name, status, isMe, tooltip }) {
  const isDone = status === 'done';
  const isCurrent = status === 'current';

  return (
    <div
      title={tooltip || undefined}
      className={`flex items-center gap-3 rounded-full border px-8 py-4 ${
        isCurrent ? 'border-sky/40 bg-sky/5' : isDone ? 'border-success/30 bg-success/5' : 'border-border bg-bg-light'
      }`}
    >
      <span
        className={`w-18 h-18 rounded-full flex items-center justify-center shrink-0 ${
          isDone ? 'bg-success/15 text-success' : isCurrent ? 'bg-sky/15 text-sky' : 'bg-bg-dark text-text-secondary'
        }`}
      >
        {isDone ? <IconCheck size={11} /> : <IconClock size={11} />}
      </span>
      <span className="text-xs font-medium whitespace-nowrap">{name || 'Unassigned'}</span>
      {isMe && <span className="text-[10px] text-primary font-medium">(you)</span>}
    </div>
  );
}

export default function ReviewStepsTimeline({ reviewSteps = [], approverName, approverId, runStatus, currentUserEmployeeId }) {
  const firstPendingIndex = reviewSteps.findIndex((s) => s.status !== 'reviewed');

  const approverStatus =
    runStatus === 'approved' || runStatus === 'published'
      ? 'done'
      : runStatus === 'submitted'
      ? 'current'
      : 'pending';

  return (
    <div className="flex flex-wrap items-center gap-6">
      {reviewSteps.map((step, index) => {
        const status = step.status === 'reviewed' ? 'done' : index === firstPendingIndex ? 'current' : 'pending';
        const tooltip = [step.reviewed_at && fmtDate(step.reviewed_at), step.notes].filter(Boolean).join(' — ');
        return (
          <React.Fragment key={step.position ?? index}>
            <StepChip
              name={step.reviewer_name}
              status={status}
              tooltip={tooltip}
              isMe={!!currentUserEmployeeId && String(step.reviewer) === String(currentUserEmployeeId)}
            />
            <IconArrowRight size={13} className="text-text-secondary shrink-0" />
          </React.Fragment>
        );
      })}
      <span className="text-[10px] uppercase text-text-secondary tracking-wide">Approver</span>
      <StepChip
        name={approverName}
        status={approverStatus}
        isMe={!!currentUserEmployeeId && !!approverId && String(approverId) === String(currentUserEmployeeId)}
      />
    </div>
  );
}
